import * as React from "react";

import withAuth from "../../utils/withAuth";
import { Card, Button, Dimmer } from "tabler-react";

import JobDetailsRecentJobs from "./JobDetailsRecentJobs.react";
import JobDetailsBlogCard from "./JobDetailsBlogCard.react";

interface Props {
  isLoading: boolean;
  isLogged: boolean;
  recentJobs: any;
  openApplyModal: Function;
  openLogin: Function;
  openRegister: Function;
  applyJob: Function;
  isApplied: boolean;
}

class JobApplyCard extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.makeTitle = this.makeTitle.bind(this);
  }

  makeTitle(title) {
    return title
      .split(" ")
      .filter(function (name) {
        return name !== "-";
      })
      .toString()
      .replace(/,/g, "-");
  }

  render() {
    const { isLoading, recentJobs } = this.props;

    // const loggedUserCard = () => (
    //   <React.Fragment>
    //     {this.props.isApplied ? (
    //       <Button color="success" className="full-width" icon="check">
    //         Applied
    //       </Button>
    //     ) : (
    //       <Button
    //         color="primary"
    //         className="full-width"
    //         onClick={this.props.applyJob}
    //       >
    //         Apply
    //       </Button>
    //     )}
    //   </React.Fragment>
    // );

    const unloggedUserCard = () => (
      <React.Fragment>
        {/* <Button
          color="primary"
          className="full-width"
          onClick={this.props.openLogin}
        >
          Login to apply
        </Button>
        <Button
          color="primary"
          className="full-width"
          onClick={this.props.openRegister}
        >
          Apply
        </Button> */}
        <Button
          color="primary"
          className="full-width"
          onClick={this.props.openApplyModal}
        >
          Apply to Job
        </Button>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Dimmer active={isLoading}>
          <Card className="job-details-card">
            <Card.Body>
              <Button.List>{unloggedUserCard()}</Button.List>
            </Card.Body>
          </Card>
          <JobDetailsRecentJobs recentJobs={recentJobs} />
          <JobDetailsBlogCard />
        </Dimmer>
      </React.Fragment>
    );
  }
}

export default withAuth(JobApplyCard);
